import ServiceBase from '@/Services/ServiceBase';

export default class VideoService extends ServiceBase {
    uploadVideo(formData) {
        return this.request('post', '/video', formData);
    }

    buildVideoUrl(filename = null) {
        if (!filename) {
            return null;
        }

        const baseUrl = this.$http.defaults.baseURL;
        return `${baseUrl}/video/${filename}`;
    }
}
